import { render } from "./ServicesBox.vue?vue&type=template&id=a3a7020e"
import script from "./ServicesBox.vue?vue&type=script&lang=js"
export * from "./ServicesBox.vue?vue&type=script&lang=js"

import "./ServicesBox.vue?vue&type=style&index=0&id=a3a7020e&lang=scss"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__